import format from '../utils/format';

export default function splitDate() {
	return {
		validate(input) {
			const opts = input.options;
			const dateElements = document.querySelectorAll('[data-combined="' + input.field + '"]');

			const padNumber = (num) => Number(num) < 10 ? `0${num}` : num;

			const date = { day: '', month: '', year: ''};
			dateElements.forEach((p) => {
				if (p.classList.contains('is-day')) {
					date.day = p.value;
				}
				if (p.classList.contains('is-month')) {
					date.month = p.value;
				}
				if (p.classList.contains('is-year')) {
					date.year = p.value;
				}
			});

			function dateValidate(year, month, day) {
				const parseMonth= parseInt(month-1);
				const d = new Date(year, parseMonth, day);
				if (d.getFullYear() == year && d.getMonth() == parseMonth && d.getDate() == day && year > 1900 && year < new Date().getFullYear()) {
					return true;
				}
				return false;
			}

			const isCompleted = date.day !== '' && date.month !== '' && date.year !== '';
			let valid = false;
			let message = opts.missingMessage;

			if (isCompleted) {
				const dataObject = new Date(`${padNumber(date.month)}/${padNumber(date.day)}/${date.year}`);
				const isValid = !Number.isNaN(dataObject.getTime());
				const isValidDate = dateValidate(date.year,date.month,date.day);
				message = opts.invalidMessage;
				if(!isValidDate) {
					message = opts.invalidMessage;
				}
				else if(isValid) {
					const maxDate = new Date();
					const isInThePast = dataObject <= maxDate;
					message = opts.futureMessage;

					if (isInThePast) {
						const maxAge = opts.maxAge || 0;
						maxDate.setDate(maxDate.getDate() - (maxAge * 365));
						const isAllowed = dataObject <= maxDate;

						message = opts.message;
						valid = isAllowed;
					}
				}
			}

			return {
				message: format(message),
				valid: valid
			};
		}
	}
};
